<div class="image-box">
  <div class="dot"></div>
  <div class="background"></div>
  <img class="image" src="{{ avatarImageURL }}" />
</div>
